import { QUERY_DEFAULTS } from '@/shared/lib/constants';
import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import { getConnectorTypesApi } from '@/entities/connector/api';
import type { ConnectorTypesResponse } from '@/entities/connector/types';

type UseConnectorTypesOptions = {
  enabled?: boolean;
};

export const useConnectorTypes = (options?: UseConnectorTypesOptions) => {
  return useQueryWithBoundary<ConnectorTypesResponse>({
    ...DEFAULT_QUERY_OPTIONS,
    queryKey: connectorKeys.types(),
    queryFn: getConnectorTypesApi,
    staleTime: QUERY_DEFAULTS.STALE_TIME.MEDIUM,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
    enabled: options?.enabled ?? true,
  });
};
